export default __webpack_public_path__ + "static/media/banner2.0a2a0e1a.jpg";